<app-q-modal>
  <ng-container slot="header">
    {{ "send_tip_to_sop_modal" | translate }}
  </ng-container>
  <ng-container slot="body">
    <form [formGroup]="form" class="form-container">
      <div class="group">
        <div>
          <app-q-search-contact
            formControlName="contactId"
            [invalid]="
              form.get('contactId').touched && !form.get('contactId').valid
            "
            [readonly]="true"
            [showCard]="true"
          ></app-q-search-contact>
          <app-q-control-errors
            name="contactId"
            [errors]="[
              { name: 'required', text: 'validation_required', when: 'touched' }
            ]"
          >
          </app-q-control-errors>
        </div>
        <div>
          <app-q-object-select
            formControlName="eaOid"
            [contactId]="form.get('contactId').value"
            [objectTypes]="['buyer', 'seller', 'potentialbuyer']"
            [inline]="true"
            [invalid]="form.get('eaOid').touched && !form.get('eaOid').valid"
          >
          </app-q-object-select>
          <app-q-control-errors
            name="eaOid"
            [errors]="[
              { name: 'required', text: 'validation_required', when: 'touched' }
            ]"
          >
          </app-q-control-errors>
        </div>
      </div>
      <ng-container
        *ngIf="isLeadSentToSoderberg$ | async as isLeadSentToSoderberg"
      >
        <ng-container *ngIf="isLeadSentToSoderberg === 'sent'">
          <div class="error-message">
            {{ "lead_already_sent_to_sop" | translate }}
          </div>
        </ng-container>

        <ng-container *ngIf="isLeadSentToSoderberg === 'not_sent'">
          <div>
            <h5 translate>send_tip_to_sop</h5>
            <p translate>send_tip_to_sop_description</p>
            <textarea rows="5" formControlName="comment"></textarea>
          </div>
        </ng-container>
      </ng-container>
    </form>
  </ng-container>
  <ng-container slot="actions">
    <div class="actions-container">
      <app-q-button
        mat-dialog-close
        (click)="closeModal()"
        buttonType="cancel"
        label="close"
        classes="margin-right"
      >
      </app-q-button>
      <app-q-button
        (click)="submit()"
        label="send"
        buttonType="save"
        [isLoading]="isWorking$ | async"
        [disabled]="
          (isLeadSentToSoderberg$ | async) !== 'not_sent' ||
          (isWorking$ | async)
        "
      >
      </app-q-button>
    </div>
  </ng-container>
</app-q-modal>
